var _rect, _rect2, _rect3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconZoomPlus(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 175,
    height: 175,
    viewBox: "0 0 175 175",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 175,
    height: 175,
    fill: "#808BA4"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 75,
    y: 37,
    width: 25,
    height: 100,
    fill: "white"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 138,
    y: 75,
    width: 25,
    height: 100,
    transform: "rotate(90 138 75)",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconZoomPlus);
export default __webpack_public_path__ + "static/media/icon-zoom-plus.df92fb2190284ded00dbc0db93e8665e.svg";
export { ForwardRef as ReactComponent };